export default "__VITE_PUBLIC_ASSET__4e66ba00__"